


























































































import {
  defineComponent,
  reactive,
  SetupContext,
  computed,
} from '@vue/composition-api'
import { defineObject } from '@/lib/define/use-define'
import moment from 'moment'

type stateType = {
  targetYear: number
  targetMonth: number
  targetDay: number
  hiddenYear: number
  hiddenMonth: number
  minAllowedYear: number
  minAllowedMonth: number
}

export default defineComponent({
  props: {
    viewTitle: {
      type: String,
      default: '',
      required: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    targetYear: {
      type: Number,
      required: false,
      default: new Date().getFullYear(),
    },
    targetMonth: {
      type: Number,
      required: false,
      default: new Date().getMonth() + 1,
    },
    targetDay: {
      type: Number,
      required: false,
      default: new Date().getDate(),
    },
    minAllowedYear: {
      type: Number,
      required: false,
      default: Number(moment(new Date('1970-01-01')).format('YYYY')),
    },
    minAllowedMonth: {
      type: Number,
      required: false,
      default: Number(moment(new Date('1970-01-01')).format('MM')),
    },
  },
  setup(props, context: SetupContext) {
    const state: stateType = reactive({
      targetYear: props.targetYear,
      targetMonth: props.targetMonth,
      targetDay: props.targetDay,
      hiddenYear: Number(
        moment(new Date())
          .add(12, 'months')
          .format('YYYY')
      ),
      hiddenMonth: Number(
        moment(new Date())
          .add(12, 'months')
          .format('MM')
      ),
      minAllowedYear: props.minAllowedYear,
      minAllowedMonth: props.minAllowedMonth,
    })

    const handlePresetTargetMonth = () => {
      if (
        state.hiddenYear <= state.targetYear &&
        state.hiddenMonth < state.targetMonth
      ) {
        state.targetMonth = state.hiddenMonth
      }
      // 最小許容年月以前の年月は選択不可とする
      if (
        state.targetYear < state.minAllowedYear ||
        (state.targetYear <= state.minAllowedYear &&
          state.targetMonth < state.minAllowedMonth)
      ) {
        state.targetYear = state.minAllowedYear
        state.targetMonth = state.minAllowedMonth
      }
    }

    const handleChangeTargetYearAndMonth = () => {
      handlePresetTargetMonth()
    }

    const handleGetData = () => {
      if (
        state.hiddenYear <= state.targetYear &&
        state.hiddenMonth < state.targetMonth
      ) {
        alert(
          `表示ができるのは${state.hiddenYear}年${state.hiddenMonth}月までです。`
        )
        return
      }
      if (
        state.targetYear < state.minAllowedYear ||
        (state.targetYear <= state.minAllowedYear &&
          state.targetMonth < state.minAllowedMonth)
      ) {
        alert(
          `表示ができるのは${state.minAllowedYear}年${state.minAllowedMonth}月以降です。`
        )
        return
      }

      context.emit('get-data', {
        targetYear: Number(state.targetYear),
        targetMonth: Number(state.targetMonth),
        targetDay: Number(state.targetDay),
      })
    }

    const dayArray = computed(() => {
      const dayArray: string[] = []
      const dayCnt = Number(
        new Date(
          Number(state.targetYear),
          Number(state.targetMonth),
          0
        ).getDate()
      )

      if (Number(state.targetDay) > dayCnt) {
        state.targetDay = dayCnt
      }

      for (let index = 1; index <= dayCnt; index++) {
        dayArray.push(String(index))
      }
      return dayArray
    })

    const yearArray = computed(() => {
      const currentYear = new Date().getFullYear()
      const yearArray = []
      let startYear = currentYear - 5
      const endYear = currentYear + 1
      for (startYear; startYear <= endYear; startYear++) {
        yearArray.push(startYear)
      }
      return yearArray
    })

    return {
      state,
      props,
      handleGetData,
      handleChangeTargetYearAndMonth,
      defineObject,
      yearArray,
      dayArray,
    }
  },
})
